/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Box, IconButton, Toolbar, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, makeStyles
} from '@material-ui/core';
import commonService from '../../services/commonService';
import useAuth from '../../hooks/useAuth';
import constants from '../../utils/constants';

const useStyle = makeStyles((theme) => ({
  rate: {
    backgroundColor: theme.palette.primary.main,
    padding: '5px',
    borderRadius: '8px',
    fontWeight: 'bold',
    border: '2px solid',
    borderColor: theme.palette.primary.main,
    fontSize: '12px',
    display: 'flex',
    flexDirection: 'column',
  }
}));

const ExchangeRate = () => {
  const { exchangeRates } = useAuth();
  const classes = useStyle();
  return (
    <Box
      sx={{
        ml: 1,
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        gap: 2,
        borderColor: 'secondary'
      }}
      className="tp-exchange__rate-wrapper"
    >
      {
        exchangeRates.map((rate, i) => (
          <Box
            key={rate.name}
            // className="tp-exchange__rate-item"
            className={classes.rate}
          >
            <Typography
              variant="caption"
              display="inline-block"
              fontWeight="bold"
            >
              {constants.currencySymbol[rate.name].toLocaleString(constants.defaultCulture)}
            </Typography>
            <Typography
              variant="h6"
              display="inline-block"
              fontWeight="bold"
              fontSize="12px"
            >
              {rate.price.toLocaleString(constants.defaultCulture)}
            </Typography>
          </Box>
        ))
      }
    </Box>
  );
};

export default ExchangeRate;
